<div
	class="bg-[#FCFCFC] lg:p-[46px] p-[26px] max-w-[981px] m-auto custom-shadow rounded-12px"
>
	<div class="text-center mb-[36px]">
		<p class="text-medium-gray text-[12px]">
			{{ 'OFFERS.PROMO_CODE' | translate }}
		</p>
		<p class="text-[#4E4B66] font-semibold leading-[26px] text-[24px]">
			{{ 'OFFERS.ADD_NEW_PROMO_CODE' | translate }}
		</p>
	</div>
	<div class="flex flex-col">
		<!-- activation status and basic info section -->
		<app-add-promo-code-basic-info
			[isAddMode]="true"
			(dataChanged)="
				dataChanged($event?.value); isBasicInfoInvalid = $event?.isInvalid
			"
		></app-add-promo-code-basic-info>
		<!-- country & price  -->
		<app-add-promo-code-country-price
			[isAddMode]="true"
			(dataChanged)="
				dataChanged($event?.value); countryPriceInvalid = $event?.isInvalid
			"
		></app-add-promo-code-country-price>
	</div>
	<button
		(click)="addPromoCode()"
		[disabled]="isBasicInfoInvalid || countryPriceInvalid"
		mat-button
		class="bg-gradient text-font-14 text-off-white rounded-[5px] w-full py-8px"
	>
		{{ 'ACTIONS.SAVE' | translate }}
	</button>
	<button
		(click)="openDialog()"
		class="bg-transparent text-font-14 border-solid border-[1px] secondry-color-Gray rounded-[5px] w-full py-8px mb-[8px]"
	>
		{{ 'ACTIONS.CANCEL' | translate }}
	</button>
</div>
